import { render, staticRenderFns } from "./credit-rate-feature.vue?vue&type=template&id=653d33f6"
import script from "./credit-rate-feature.vue?vue&type=script&lang=js"
export * from "./credit-rate-feature.vue?vue&type=script&lang=js"
import style0 from "./credit-rate-feature.vue?vue&type=style&index=0&id=653d33f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports